import { useEffect, useState } from 'react';
import { getTruckDistanceGaps, type TruckDistanceGaps } from '../distance-agreement.api';

export type TruckDistanceGapsState = { status: 'loading' } | { status: 'loaded'; gaps: TruckDistanceGaps } | { status: 'unavailable' };

/**
 * A truck's flagged trips for the truck record (gitaumoses4/chukua#109). A failed read, or a viewer without `distance.view` (the server refuses), only
 * hides the section: the rest of the record still works.
 */
export function useTruckDistanceGaps(truckId: string): TruckDistanceGapsState {
  const [result, setResult] = useState<{ truckId: string; state: TruckDistanceGapsState } | null>(null);

  useEffect(() => {
    let cancelled = false;
    getTruckDistanceGaps(truckId)
      .then((gaps) => {
        if (!cancelled) setResult({ truckId, state: { status: 'loaded', gaps } });
      })
      .catch(() => {
        if (!cancelled) setResult({ truckId, state: { status: 'unavailable' } });
      });
    return () => {
      cancelled = true;
    };
  }, [truckId]);

  // A result for another truck is stale: show the skeleton until this truck's own arrives.
  return result?.truckId === truckId ? result.state : { status: 'loading' };
}
